












































































































































































































































































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";
import moment from "moment";
import { isAI } from "@/libs/utils";
import _ from "lodash";
import filesaver from "file-saver";
import html2canvas from "html2canvas";

import XLSX from "xlsx";

import MyConfig from "@/config";
import ModalReconciliation from "./modalreconciliation.vue";

import AuditDetail from "./audit_detail.vue";

@Component({
  components: {
    ModalReconciliation,
    AuditDetail
  }
})
export default class extends Mixins(MyForm) {
  @Prop() oldData!: any;

  @Prop() stadiumId!: number;

  @Prop() type!: number;

  apiserver: string = MyConfig.casapi;

  auditDetailModalVisible = false;

  clickParams = {};

  modal1Visible = false;

  modal1Mobile = "";

  detailObj: any[] = [];

  members_payment_cost = 0;

  sms_cost = 0;

  compareresult = 0;

  mchstartdate = "";

  matchedTradeno: string[] = [];

  unmatchedTradeno: string[] = [];

  unmatchedPrice: string[] = [];

  rechargeMatchedTradeno: string[] = [];

  rechargeUnmatchedTradeno: string[] = [];

  rechargeUnmatchedPrice: string[] = [];

  isMatch = false;

  tableData: any[] = [];

  tableHumanData: any[] = [];

  tableSmsData: any[] = [];

  tableRechargeData: any[] = [];

  order_sum = 0;

  human_sum = 0;

  recharge_sum = 0;

  sms_sum = 0;

  isNew = false;

  detailJson: { [t: string]: any } = {};

  equation = "";

  equation_value = "";

  equation_result = "0";

  // detail 接口返还的结算额
  detailMoney = 0;

  process: any[] = [];

  isPrint = false;

  reconciliationcolumns: any[] = [
    {
      title: "编号",
      dataIndex: "id"
    },
    {
      title: "用户名称",
      dataIndex: "username"
    },
    { title: "手机号", dataIndex: "mobile" },
    {
      title: "账面平台余额",
      scopedSlots: { customRender: "user_balance_total" }
    },
    {
      title: "账面场馆余额",
      scopedSlots: { customRender: "stadium_balance_total" }
    },
    {
      title: "追账平台余额",
      scopedSlots: { customRender: "user_balance_total_check" }
    },
    {
      title: "追账场馆余额",
      scopedSlots: { customRender: "stadium_balance_total_check" }
    },
    { title: "对账时间", dataIndex: "check_time" },
    { title: "对账结果", scopedSlots: { customRender: "result" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  columns_title: any[] = [
    {
      title: "序号",
      customRender: (text: any, record: any, index: number) => index + 1
    },
    { title: "编号", scopedSlots: { customRender: "id" } },
    { title: "联系人", scopedSlots: { customRender: "username" } },
    { title: "手机号", dataIndex: "user_mobile" },
    { title: "场时", dataIndex: "cost_desc" },
    { title: "价格", scopedSlots: { customRender: "cost" } },
    { title: "结算金额", scopedSlots: { customRender: "settle_fee" } },
    { title: "微信金额", scopedSlots: { customRender: "wechat_fee" } },
    { title: "增收金额", scopedSlots: { customRender: "sum_money" } },
    { title: "入账金额", scopedSlots: { customRender: "sum_settle_money" } },
    { title: "下单时间", dataIndex: "created_time" },
    { title: "打球结束时间", dataIndex: "valid_time_end" },
    { title: "订单类型", dataIndex: "ordertype" },
    { title: "支付方式", dataIndex: "channel_name" },
    {
      title: "交易单号",
      dataIndex: "trade_no",
      customCell: (record: any, rowIndex: any) => ({
        class: [`${record.cellClassName}`, record.id]
      })
    }
  ];

  columns_human: any[] = [
    {
      title: "序号",
      customRender: (text: any, record: any, index: number) => index + 1
    },
    { title: "所属年份", dataIndex: "own_year" },
    { title: "所属月份", dataIndex: "own_month" },
    { title: "金额", scopedSlots: { customRender: "fee" } }
  ];

  columns_sms: any[] = [
    {
      title: "序号",
      customRender: (text: any, record: any, index: number) => index + 1
    },
    { title: "手机号", dataIndex: "mobile" },
    { title: "发送时间", dataIndex: "send_time" }
  ];

  columns_recharge: any[] = [
    {
      title: "序号",
      customRender: (text: any, record: any, index: number) => index + 1
    },
    { title: "手机号", dataIndex: "mobile" },
    { title: "时间", dataIndex: "created_time" },
    { title: "金额", scopedSlots: { customRender: "fee" } },
    { title: "微信金额", scopedSlots: { customRender: "wechat_fee" } },
    {
      title: "交易单号",
      dataIndex: "trade_no",
      customCell: (record: any, rowIndex: any) => ({
        class: [`${record.cellClassName}`, record.id]
      })
    },
    { title: "微信的交易单号", dataIndex: "transaction_id" },
    { title: "支付方式", dataIndex: "channel_name" }
  ];

  exportBill() {
    const data = [
      [
        "序号",
        "编号",
        "联系人",
        "手机号",
        "场时",
        "价格",
        "结算金额",
        "微信金额",
        "增收金额",
        "入账金额",
        "下单时间",
        "打球结束时间",
        "订单类型",
        "支付方式",
        "交易单号"
      ]
    ];

    for (const idx in this.tableData) {
      if (this.tableData[idx]) {
        const obj = this.tableData[idx];
        data.push([
          Number(idx) + 1,
          obj.id,
          obj.username,
          obj.user_mobile,
          obj.cost_desc,
          this.renderMoney(obj.cost / 100),
          this.renderMoney(obj.settle_fee / 100),
          this.renderMoney(obj.wechat_fee / 100),
          this.renderMoney(obj.sum_money / 100),
          this.renderMoney(obj.sum_settle_money / 100),
          obj.created_time,
          obj.valid_time_end,
          obj.ordertype,
          obj.channel_name,
          obj.trade_no
        ]);
      }
    }
    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const new_workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(new_workbook, worksheet, "SheetJS");

    const wopts: XLSX.WritingOptions = { bookType: "xlsx", bookSST: false, type: "array" };

    const wbout = XLSX.write(new_workbook, wopts);

    filesaver.saveAs(
      new Blob([wbout], { type: "application/octet-stream" }),
      `结算${this.oldData.id}订场订单.xlsx`
    );
  }

  exportRecharge() {
    const data = [
      ["序号", "手机号", "时间", "金额", "微信金额", "交易单号", "微信的交易单号", "支付方式"]
    ];

    for (const idx in this.tableRechargeData) {
      if (this.tableRechargeData[idx]) {
        const obj = this.tableRechargeData[idx];
        data.push([
          Number(idx) + 1,
          obj.mobile,
          obj.created_time,
          this.renderMoney(obj.fee / 100),
          this.renderMoney(obj.bill_fee_total > 0 ? obj.bill_fee_total / 100 : obj.fee_total / 100),
          obj.trade_no,
          obj.transaction_id,
          obj.channel_name
        ]);
      }
    }
    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const new_workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(new_workbook, worksheet, "SheetJS");

    const wopts: XLSX.WritingOptions = { bookType: "xlsx", bookSST: false, type: "array" };

    const wbout = XLSX.write(new_workbook, wopts);

    filesaver.saveAs(
      new Blob([wbout], { type: "application/octet-stream" }),
      `结算${this.oldData.id}会员卡订单.xlsx`
    );
  }

  toList(obj: any) {
    if (obj.click && !obj.click.disabled) {
      if (!["cost_sms", "cost_pay"].includes(obj.click.key)) {
        this.clickParams = obj;
        this.auditDetailModalVisible = true;
      }
    }
  }

  hideAuditDetailModal() {
    this.auditDetailModalVisible = false;
  }

  getCanvasBlob(canvas: any) {
    return new Promise((resolve, reject) => {
      canvas.toBlob((blob: any) => {
        resolve(blob);
      });
    });
  }

  handleAudit(name: string, oldData:any) {
	if (oldData.is_correct && oldData.is_correct > 0 && !oldData.correct_result) {
		this.$confirm({
			content:'技术人员尚未填写纠错日志，不能进行此操作',
		})
	}else{
		this.showTsConfirm({
		  title: "确认消息",
		  content: "你确定要进行该操作吗？",
		  onOk: async () => {
			this.confirmLoading = true;
			let audit_status = 1;

			let capture = "";

			let dispatchUri = "finance/audit";
			if (name === "allow") {
			  this.isPrint = true;
			  audit_status = 2;
			  const elem: any = document.querySelector("#capture");
			  const canvas: any = await html2canvas(elem);
			  capture = canvas.toDataURL("image/png");
			} else if (name === "deny") {
			  audit_status = 3;
			  dispatchUri = "finance/auditNormal";
			}

			const res = await this.$store.dispatch(dispatchUri, {
			  id:this.oldData.settlement_record_id?this.oldData.settlement_record_id:oldData.id,
			  audit_status,
			  capture
			});

			console.log(res,'提交成功');

			if (name == "deny") {
			  if (res && res.Message && res.Message == "success") {
				this.$message.success("操作成功");
				this.handleCancel();
			  } else {
				this.$message.error("操作失败");
			  }
			} else {
			  this.isPrint = false;
			  if (res && res.data) {
				// this.$message.success(res.Message)
				// const blob = new Blob([res.data], { type: "application/pdf" });
				// filesaver.saveAs(
				//   blob,
				//   `${this.oldData.stadium_name}付款申请单${moment().format(
				//     "YYYY-MM-DD HH:mm:ss"
				//   )}.pdf`
				// );
				this.$message.success("操作成功");

				this.handleCancel();
				//   this.loadData()
			  } else {
				this.$message.error("操作失败");
			  }
			}

			this.confirmLoading = false;
		  }
		});
	}

  }

  async mounted() {

    this.spinLoading = true;

    this.oldData.date_from =
      this.oldData.date_from.indexOf(":") !== -1
        ? this.oldData.date_from
        : `${this.oldData.date_from} 00:00:00`;

    this.oldData.date_end =
      this.oldData.date_end.indexOf(":") !== -1
        ? this.oldData.date_end
        : `${this.oldData.date_end} 00:00:00`;

    // B端的结算项目列表
    if (this.oldData.settle_type === "1") {
      // 微信结算
      this.isNew = true;

      const res0 = await this.$store.dispatch("finance/getSettlementDetail1", {
        id: this.oldData.settlement_record_id?this.oldData.settlement_record_id:this.oldData.id,
        stadium_id: this.stadiumId
      });
      if (res0 && res0.Data) {
        // console.log(res0.Data);
        this.detailObj = res0.Data.items;
        this.oldData.date_from = res0.Data.settle_start_time;
        this.oldData.date_end = res0.Data.settle_end_time;

        if (_.has(res0.Data, "settle_money")) {
          this.detailMoney = res0.Data.settle_money;
        } else {
          this.detailMoney = this.oldData.earning;
        }
      }
    } else {
      
      // 银行卡结算

      if (this.oldData.detail_json) {
        this.detailJson = JSON.parse(this.oldData.detail_json);
      }
      // console.log(this.oldData);
      if (_.has(this.detailJson, ["old"]) == true || this.oldData.version != "0") {
        this.isNew = true;
        let res0 = []

        if(this.oldData.type != 'error'){
          res0 = await this.$store.dispatch("finance/getSettlementDetail1", {
            id: this.oldData.settlement_record_id?this.oldData.settlement_record_id:this.oldData.id,
            stadium_id: this.stadiumId
          });
        }else{
          console.log(this.oldData.id,5555)
          res0 = await this.$store.dispatch("finance/errorCorrectionDetail", {
            id: this.oldData.id
          });
          if (_.has(res0.Data, "settle_money")) {
            res0.Data.settle_money=this.oldData.earning;
          }
        }
        
        console.log(res0,99999)
        if (res0 && res0.Data) {
          // console.log(res0.Data)
          this.detailObj = res0.Data.items;

          this.oldData.date_from = res0.Data.settle_start_time;
          this.oldData.date_end = res0.Data.settle_end_time;

          if (_.has(res0.Data, "settle_money")) {
            this.detailMoney = res0.Data.settle_money;
          } else {
            this.detailMoney = this.oldData.earning;
          }
        }
      } else {

         const res0 = await this.$store.dispatch("finance/getSettlementDetail", {
            id:this.oldData.settlement_record_id?this.oldData.settlement_record_id:this.oldData.id,//是否結算糾錯
            stadium_id: this.stadiumId
          });
        if (res0 && res0.Data) {
          // console.log(res0.Data)
          this.detailObj = res0.Data;

          if (_.has(res0.Data, "settle_money")) {
            this.detailMoney = res0.Data.settle_money;
          } else {
            this.detailMoney = this.oldData.earning;
          }
        }
      }
    }

    // 管理后台的结算项目列表
    await this.loadSettlementItems();
    if(this.oldData.type !== 'error'){//如果是银行卡
      this.loadProcess();
    }

    this.spinLoading = false;
  }

  async loadProcess() {
    this.$store
      .dispatch("finance/process", {
        settlement_record_id: this.oldData.id
      })
      .then(res => {
        if (res && res.Data) {
          this.process = res.Data;
        }
      });
  }

  async reNoticeProcess(itm: any) {
    this.showTsConfirm({
      title: "确认信息",
      content: "你确定要操作吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("finance/reNoticeProcess", {
          settlement_record_id: this.oldData.settlement_record_id?this.oldData.settlement_record_id:this.oldData.id,
          step: itm.step
        });

        if (res && res.Message && res.Message == "success") {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  print(id: number) {
    this.$confirm({
      title: "确认消息",
      content: "你确定要打印付款申请单吗？",
      onOk: async () => {
        this.isPrint = true;
        this.confirmLoading = true;
        let audit_status = 1;

        let capture = "";

        audit_status = 2;
        const elem: any = document.querySelector("#capture");
        const canvas: any = await html2canvas(elem);
        capture = canvas.toDataURL("image/png");

        const res = await this.$store.dispatch("finance/audit", {
          id:this.oldData.settlement_record_id?this.oldData.settlement_record_id:id,
          audit_status,
          capture,
          is_print: "1"
        });
        console.log(res,789)
        if (res && res.data) {
          if(this.oldData.type != 'error'){
            if (res.data.type == "application/json") {
              this.$message.error("流程还没走完");
              this.confirmLoading = false;
              return;
            }
          }

          // this.$message.success(res.Message)
          const blob = new Blob([res.data], { type: "application/pdf" });
          filesaver.saveAs(
            blob,
            `${this.oldData.stadium_name}付款申请单${moment().format("YYYY-MM-DD HH:mm:ss")}.pdf`
          );

          // this.handleCancel();
          //   this.loadData()
          this.$message.success('成功打印');
        } else {
          this.$message.error(res.Message);
        }
        this.isPrint = false;
        this.confirmLoading = false;
      }
    });
  }
  async loadSettlementItems() {
	  let res;
	  if(this.oldData.type == 'error'){//结算纠错
		 res =  await this.$store.dispatch("finance/errorCorrectionItems",{
		 		  id:this.oldData.id
		 		});
	  }else{
		 res = await this.$store.dispatch("finance/getSettlementItems", {
		    settlement_id:this.oldData.id,
		    stadium_id: this.stadiumId
		  });
	  }


    console.log(res);
    if (res && res.Data) {
      this.equation = res.Data.equation;
      this.equation_value = res.Data.equation_value;
      this.equation_result = res.Data.equation_result;
      // console.log(this.detailObj);

      if (this.oldData.id == "0") {
        if (Number(this.equation_result) === Number(this.detailMoney / 100)) {
          this.isMatch = true;
        }
      } else {
        if (Number(this.equation_result) === Number(this.oldData.earning / 100)) {
          this.isMatch = true;
        }
      }

      this.order_sum = res.Data.order_sum;
      let data: any[] = [];
      for (const k in res.Data.bill) {
        if (res.Data.bill[k].data) {
          //   console.log(res.Data.bill[k].data);
          data = _.concat(data, res.Data.bill[k].data);
        }
      }
      if (data.length > 0) {
        const obj1: any = _.minBy(data, (o: any) => o.created_time);
        this.mchstartdate = moment(obj1.created_time)
          .subtract(14, "days")
          .format("YYYY-MM-DD 00:00:00");
      }

      //   console.log(data);
      this.tableData = _.orderBy(data, ["created_time"], ["desc"]);
      this.sms_sum = res.Data.cost_sms.count;
      this.tableSmsData = res.Data.cost_sms.data;
      this.recharge_sum = res.Data.vip_recharge_sum;

      let data1: any[] = [];
      for (const k in res.Data.vip_recharge_bill) {
        if (res.Data.vip_recharge_bill[k].data) {
          data1 = _.concat(data1, res.Data.vip_recharge_bill[k].data);
        }
      }

      this.tableRechargeData = _.orderBy(data1, ["created_time"], ["desc"]);
      this.human_sum = res.Data.cost_member.sum_settle_money;
      this.tableHumanData = res.Data.cost_member.data;
    }
  }

  customRow(record: any) {
    return {
      on: {
        click: () => {
          // console.log(record)
          if (record.channel_code !== "wechat_app") {
            // 弹出对账
            this.modal1Mobile = record.user_mobile;
            this.modal1Visible = true;
          }
        }
      }
    };
  }

  hideModal1() {
    this.modal1Visible = false;
  }

  handleBeforeUpload(file: any) {
    const params = new FormData();
    params.append("chunk", "0");
    params.append("chunks", "1");
    params.append("filename", file, file.name);
    params.append("settlement_id", this.oldData.settlement_record_id?this.oldData.settlement_record_id:this.oldData.id);
    this.$store.dispatch("bill/compareSettlement", params).then(res => {
      this.setMatched(res.Data);
    });
    return false;
  }

  handleCompareWithDatabase() {
    this.$store
      .dispatch("bill/compareWithDatabase", {
        settlement_record_id: this.oldData.id
      })
      .then(res => {
        if (res && res.Message && res.Message === "success") {
          this.setMatched(res.Data);
        } else {
          this.$message.error(res.Message);
        }
      });
    return false;
  }

  async downTradeBill() {
    const res = await this.$store.dispatch("finance/downTradeBill", {});
    if (res && res.Message && res.Message === "success") {
      this.$message.success(res.Message);
    } else {
      this.$message.error(res.Message);
    }
  }

  setMatched(data: any) {
    this.matchedTradeno = data.validarr;
    this.unmatchedTradeno = data.invalidarr;
    this.unmatchedPrice = data.pricearr;

    this.rechargeMatchedTradeno = data.recharge_validarr;
    this.rechargeUnmatchedTradeno = data.recharge_invalidarr;
    this.rechargeUnmatchedPrice = data.recharge_pricearr;

    // console.log(this.unmatchedTradeno)
    for (let i = 0; i < this.tableData.length; i += 1) {
      if (_.indexOf(this.matchedTradeno, this.tableData[i].trade_no) !== -1) {
        // _.set(this.tableData, [i, 'cellClassName'], { ordertype: 'demo-table-info-cell-red' })
        _.set(this.tableData, [i, "cellClassName"], "demo-table-info-cell-red");
        _.set(this.tableData, [i, "id"], `${this.tableData[i].id} `);
      } else if (_.indexOf(this.unmatchedPrice, this.tableData[i].trade_no) !== -1) {
        // _.set(this.tableData, [i, 'cellClassName'], { ordertype: 'demo-table-info-cell-red' })
        _.set(this.tableData, [i, "cellClassName"], "demo-table-info-cell-yellow");
        _.set(this.tableData, [i, "id"], `${this.tableData[i].id} `);
      } else {
        _.set(this.tableData, [i, "cellClassName"], "");
        _.set(this.tableData, [i, "id"], `${this.tableData[i].id} `);
      }

      if (this.tableData[i].channel_code !== "wechat_app") {
        // 要加载下
        // this.$store
        //   .dispatch('finance/checkByUser', {
        //     user_id: this.tableData[i].user_id,
        //   })
        //   .then((res) => {
        //     if (res && res.Data) {
        //       if (parseInt(res.Data, 10) === 2) {
        //         _.set(
        //           this.tableData,
        //           [i, 'cellClassName'],
        //           'demo-table-info-cell-error',
        //         );
        //         _.set(this.tableData, [i, 'id'], `${this.tableData[i].id} `);
        //       }
        //     }
        //   });
      }
    }
    // console.log(this.tableData)

    for (let i = 0; i < this.tableRechargeData.length; i += 1) {
      if (_.indexOf(this.rechargeMatchedTradeno, this.tableRechargeData[i].transaction_id) !== -1) {
        _.set(this.tableRechargeData, [i, "cellClassName"], "demo-table-info-cell-red");
        _.set(this.tableRechargeData, [i, "id"], `${this.tableRechargeData[i].id} `);
      } else if (
        _.indexOf(this.rechargeUnmatchedPrice, this.tableRechargeData[i].transaction_id) !== -1
      ) {
        _.set(this.tableRechargeData, [i, "cellClassName"], "demo-table-info-cell-yellow");
        _.set(this.tableRechargeData, [i, "id"], `${this.tableRechargeData[i].id} `);
      } else {
        _.set(this.tableRechargeData, [i, "cellClassName"], "");
        _.set(this.tableRechargeData, [i, "id"], `${this.tableRechargeData[i].id} `);
      }
    }

    if (
      !_.isEmpty(this.unmatchedPrice) ||
      !_.isEmpty(this.rechargeUnmatchedPrice) ||
      !_.isEmpty(this.unmatchedTradeno) ||
      !_.isEmpty(this.rechargeUnmatchedTradeno)
    ) {
      this.compareresult = 1;
    } else {
      this.compareresult = 2;
    }

    this.$message.success("比较结束");
  }

  rowClassName(row: any, index: number) {
    if (row.channel_code !== "wechat_app") {
      return "demo-table-notwechatapp-row";
    }
    return "";
  }
}
